/** True for Excel footer/summary rows that must never become projects (e.g. TOTAL=). */
export function isExcelSummaryProjectName(name: string): boolean {
    const p = (name || '').trim();
    if (!p) return true;
    if (/^total\s*=?\s*$/i.test(p)) return true;
    if (/^(grand\s*)?total\b/i.test(p) || /sub\s*total/i.test(p)) return true;
    if (/^total\b/i.test(p) && !/[a-z]{4,}/i.test(p.replace(/^total\s*=?\s*/i, ''))) return true;
    return false;
}

export function isNonImportableExcelRow(
    projName: string,
    schemeName: string,
    villageRaw = ''
): boolean {
    const p = projName.trim();
    const s = schemeName.trim();
    const v = villageRaw.trim();
    if (!p) return true;
    if (isExcelSummaryProjectName(p) || (v && isExcelSummaryProjectName(v))) return true;

    const exactLabel = /^(total|project name|name of project|name of the project|work name|sl\.?\s*no\.?|name|names?|village|name of the village|name of village|scheme|name of scheme|estimate|estimated cost|estmate cost|cost|status|remarks|\d+\.?)$/i;
    if (exactLabel.test(p) || exactLabel.test(s) || (v && exactLabel.test(v))) return true;

    return false;
}
